module.exports = __webpack_public_path__ + "img/reset.56c318c3.svg";